import React, { Component } from 'react';
import { Col, Row, Card, CardBody, CardHeader } from 'reactstrap';
import { Helmet } from 'react-helmet';
import ScheduleDemo from '../ScheduleDemo/index';
import { withRouter, Link } from 'react-router-dom'

import './index.css';
import Cookies from 'js-cookie';

// import about from '../../assets/img/about/about-1.png';
// import aboutSec from '../../assets/img/about/about-2.png';
// import aboutThrd from '../../assets/img/about/about-3.png';
// import aboutFrth from '../../assets/img/about/about-4.png';
// import aboutFifth from '../../assets/img/about/about-5.png';

class About extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false
    }
  }

  getClickHereLink = () => {
    return (<Link to={'add-your-company'}>&nbsp;here</Link>)

    if (this.state.isLoggedIn) {
      return (<Link to={'add-your-company'}>&nbsp;here</Link>)
    } else {
      return (
        <React.Fragment>
          &nbsp;after joining <Link to={'join'}>here</Link>
        </React.Fragment>
      )
    }
  }



  render() {
    return (
      <div className="animated fadeIn mainView">
        
        <Card className='modifyCard'>
          <CardHeader className='cardHeader border-bottom pb-5'>
            <div className='row '>
              <div className='col-12 col-sm-6 order-sm-1 order-2 d-flex justify-content-start align-items-start flex-column'>
                <h1 style={{ color: '#474866', fontSize: 60, fontWeight: 'bold', margin: 0 }}>Company Data API by Growjo</h1>
                <h2 style={{ color: '#FC8600', fontSize: 24, margin: 0, marginTop: 10, fontWeight: 'bold' }}>What are the sources of your company data?</h2>
                <p className='pt-4'>Growjo’s dataset comes from multiple sources. Some of the revenue, employee and valuation information comes directly from the company themselves, some from blog posts our research team finds online, some companies are public and have to report this information, and finally some from our proprietary algorithm that takes the above data and calculates the company’s estimated revenue. Employee count data is easier to get and estimate depending on the industry the company is in.</p>
              </div>
              <div className='col-12 col-sm-6 order-sm-2 order-1 d-flex justify-content-center align-items-center'>
                <img style={{ maxHeight: '240px' }} src={'/static/about/about-1.png'} />
              </div>
            </div>
          </CardHeader>
          <CardBody>

            <div className='row py-5'>
              <div className='col-12 col-sm-6 order-sm-1 order-2 d-flex justify-content-center align-items-start flex-column'>
                <h3 style={{ color: '#474866', fontSize: 21, fontWeight: 'bold', margin: 0 }}>Source 1: User Generated Content

                </h3>

                <p className='pt-4'>Many companies want to be listed within the Growjo fastest growing company lists so they submit their data to us. Growjo gets 1M visits per month so this is great exposure for them. These submissions include the past 12 months revenue, number of employees, number of employees 1 year ago, industry, keywords, funding information, etc. If you want to be included in Growjo please submit your company
                  {this.getClickHereLink()}
                  .</p>
              </div>
              <div className='col-12 col-sm-6 order-sm-2 order-1 d-flex justify-content-center align-items-center'>
                <img style={{ maxHeight: '240px' }} src={'/static/about/about-2.png'} />
              </div>
            </div>
            <div className='row '>
              <div className='col-12 col-sm-6  order-2 d-flex justify-content-center align-items-start align-items-sm-end flex-column'>
                <h3 style={{ color: '#474866', fontSize: 21, fontWeight: 'bold', margin: 0 }}>Source 2: Blog Posts and News Outlets
                </h3>

                <p className='pt-4 text-left text-sm-right'>Our research team scours the web to find blog posts that mention fundings and other news events which will lead to annual revenue figures, number of employees and valuation numbers.</p>
              </div>
              <div className='col-12 col-sm-6  order-1 d-flex justify-content-center align-items-center'>
                <img style={{ maxHeight: '240px' }} src={'/static/about/about-3.png'} />
              </div>
            </div>
            <div className='row '>
              <div className='col-12 col-sm-6 order-sm-1 order-2 d-flex justify-content-center align-items-start flex-column'>
                <h3 style={{ color: '#474866', fontSize: 21, fontWeight: 'bold', margin: 0 }}>Source 3: Public Company Quarterly Reports</h3>

                <p className='pt-4'>Our focus is mostly on private company data as that is much harder to get information on.  However, public companies have to disclose their revenue and profits every quarter so we use this data to figure out their past 12 months revenue, etc.</p>
              </div>
              <div className='col-12 col-sm-6 order-sm-2 order-1 d-flex justify-content-center align-items-center'>
                <img style={{ maxHeight: '240px' }} src={'/static/about/about-4.png'} />
              </div>
            </div>
            <div className='row '>
              <div className='col-12 col-sm-6  order-2 d-flex justify-content-center align-items-start align-items-sm-end flex-column'>
                <h3 style={{ color: '#474866', fontSize: 21, fontWeight: 'bold', margin: 0 }}>Source 4: Growjo Algorithms</h3>

                <p className='pt-4 text-left text-sm-right'>We use all of the data above in order to calculate an estimated revenue based on the number of employees they have, the specific sector they are in, the country their employees are in, and funding amount. Every time we get more data from the sources above we add it to our algorithm so the calculation gets better.</p>
              </div>
              <div className='col-12 col-sm-6  order-1 d-flex justify-content-center align-items-center'>
                <img style={{ maxHeight: '240px' }} src={'/static/about/about-5.png'} />
              </div>
            </div>
          </CardBody>
        </Card>
        <ScheduleDemo />
        <Helmet>
          <title>Company Data API by Growjo</title>
          <meta name="description" content="Company Revenue Database API by Growjo" />
          <meta name="author" content="Growjo"></meta>
        </Helmet>

      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./client/src/views/AboutOurData/index.js